import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';

import { interventionActions } from '../index';
import { IArchiveThreadMessageRequestAction } from '../reducers/archiveThreadMessage/request';

function* archiveThreadMessage(
  action: PayloadAction<IArchiveThreadMessageRequestAction>,
) {
  try {
    yield call(
      rikHttpClient.put,
      `messages/${action.payload.data.id}/archive_thread_message`,
    );

    yield put(interventionActions.archiveThreadMessageSuccess());
    action.payload.functions.close();
  } catch (err: any) {
    action.payload.functions.error(err);

    yield put(interventionActions.archiveThreadMessageFailure());
  }
}

export default archiveThreadMessage;
